import moment from "moment";
import { format } from "date-fns";
import { de } from "date-fns/locale/de";
import { es } from "date-fns/locale/es";
import { fr } from "date-fns/locale/fr";
import { it } from "date-fns/locale/it";

const DATE_FNS_LOCALES = { de, es, fr, it };

export function getDatepickerLocale(language) {
	const code = String(language || "").slice(0, 2).toLowerCase();
	return DATE_FNS_LOCALES[code];
}

export function formatDatepickerMonthName(date, language) {
	const locale = getDatepickerLocale(language);
	if (!locale) {
		return moment(date).format("MMMM");
	}
	const name = format(date, "LLLL", { locale });
	return name.charAt(0).toUpperCase() + name.slice(1);
}
